/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PaypalService {

    /**
     * Paypal Webhook
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static paypalWebhook(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/paypal/webhook',
        });
    }

}
